import { useMutation } from "@tanstack/react-query";
import { userLoginApi } from "./auth.api";
import { QUERY_KEYS } from "../querykeys";
import { AuthApiResponse } from "types/auth";
import { LoginFormPayload } from "types/auth";

export const useUserLoginMutation =()=>{
    return useMutation<AuthApiResponse,Error,LoginFormPayload>({
        mutationKey:[QUERY_KEYS.USER_LOGIN],
        mutationFn:userLoginApi,
    })
};